import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AttributeDataType } from '@src/app/shared/enums/AttributeDataType.enum';

@Injectable({
  providedIn: 'root'
})
export class ProductAttributeDataTypeService {

  constructor(public translate: TranslateService) {}

  getProductAttributeDataTypeOptions(): { label: string; value: AttributeDataType }[] {
    return [
      { label: this.translate.instant('PRODUCT_ATTRIBUTES_DEFINITIONS_CREATE.DATA_TYPE_FIXED_VALUES'), value: AttributeDataType.FIXED_VALUES },
      { label: this.translate.instant('PRODUCT_ATTRIBUTES_DEFINITIONS_CREATE.DATA_TYPE_DECIMAL'), value: AttributeDataType.DECIMAL },
      { label: this.translate.instant('PRODUCT_ATTRIBUTES_DEFINITIONS_CREATE.DATA_TYPE_INTEGER'), value: AttributeDataType.INTEGER },
      { label: this.translate.instant('PRODUCT_ATTRIBUTES_DEFINITIONS_CREATE.DATA_TYPE_TEXT'), value: AttributeDataType.TEXT }
    ];
  }
}
